<template>
  <v-sheet
    color="white"
    width="96px"
    height="80px"
    class="d-flex flex-column justify-center align-center"
    rounded
  >
    <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>
    <span class="text--secondary">
      {{ t('upload.loading') }}
    </span>
  </v-sheet>
</template>

<script setup lang="ts">
import { useI18n } from '#imports';

const { t } = useI18n();
</script>
